{
  "sidebar": {
    "dashboard": "لوحة التحكم",
    "titles": "العناوين",
    "services": "الخدمات",
    "billing": "الفاتورة",
    "publishers": "الناشرون",
    "enterprise": "المؤسسات",
    "settings": "الإعدادات",
    "profile": "الملف الشخصي",
    "signOut": "تسجيل الخروج",
    "notifications": "الإشعارات",
    "publishing": "النشر",
    "management": "إدارة",
    "sectionDashboard": "لوحة التحكم",
    "publisherPanel": "لوحة الناشر",
    "adminPanel": "لوحة الإدارة",
    "legal": "القانونية",
    "pinSidebar": "تثبيت الشريط الجانبي",
    "unpinSidebar": "إلغاء تثبيت الشريط الجانبي",
    "language": "العربية",
    "mobileNav": "القائمة",
    "openMenu": "فتح القائمة",
    "closeMenu": "إغلاق القائمة",
    "account": "الحساب",
    "home": "الصفحة الرئيسية"
  },
  "themeToggle": {
    "label": "تبديل المظهر"
  },
  "nav": {
    "dashboard": "لوحة التحكم",
    "titles": "العناوين",
    "files": "الملفات",
    "settings": "الإعدادات",
    "logout": "تسجيل الخروج",
    "admin": "إدارة"
  },
  "common": {
    "save": "حفظ",
    "cancel": "إلغاء",
    "delete": "حذف",
    "edit": "تعديل",
    "add": "إضافة",
    "back": "رجوع",
    "next": "التالي",
    "previous": "السابق",
    "loading": "جارٍ التحميل...",
    "error": "حدث خطأ",
    "success": "نجاح",
    "confirm": "تأكيد",
    "search": "بحث",
    "all": "الكل",
    "noResults": "لا توجد نتائج",
    "actions": "الإجراءات",
    "imageBroken": "تالفة",
    "errors": {
      "notFound": "الصفحة غير موجودة",
      "notFoundDescription": "الصفحة التي تبحث عنها غير موجودة أو تم نقلها.",
      "serverError": "خطأ في الخادم",
      "serverErrorDescription": "حدث خطأ ما. يرجى المحاولة مرة أخرى لاحقًا.",
      "requestFailed": "فشل الطلب",
      "requestFailedDescription": "تعذّر إكمال طلبك. يرجى المحاولة مرة أخرى.",
      "goToDashboard": "الذهاب إلى لوحة التحكم",
      "backToLogin": "العودة إلى تسجيل الدخول",
      "generic": "حدث خطأ. يرجى المحاولة مرة أخرى.",
      "validation": "يرجى تصحيح الحقول المميزة."
    }
  },
  "status": {
    "approved": "معتمد",
    "pending": "قيد الانتظار",
    "suspended": "موقوف",
    "editing": "قيد التعديل"
  },
  "roles": {
    "admin": "مدير",
    "publisher": "ناشر"
  },
  "brandName": "أورنمو للنشر",
  "brandNameShort": "أورنمو",
  "copyright": "© {{year}} UR-NAMMU PUBLISHING LTD",
  "notifications": {
    "title": "الإشعارات",
    "markAllRead": "تعيين الكل كمقروء",
    "viewAll": "عرض جميع الإشعارات",
    "emptyTitle": "لا توجد إشعارات بعد",
    "emptyDesc": "أنت على اطلاع بآخر المستجدات. ستظهر الإشعارات الجديدة هنا.",
    "loadError": "فشل تحميل الإشعارات."
  },
  "pageTitles": {
    "login": "أورنمو للنشر | تسجيل الدخول",
    "register": "أورنمو للنشر | إنشاء حساب",
    "forgotPassword": "أورنمو للنشر | استعادة كلمة المرور",
    "resetPassword": "أورنمو للنشر | تعيين كلمة المرور",
    "verifyEmail": "أورنمو للنشر | التحقق من البريد الإلكتروني",
    "dashboard": "أورنمو للنشر | لوحة التحكم",
    "adminDashboard": "أورنمو للنشر | لوحة تحكم الإدارة"
  },
  "dashboard": {
    "eyebrow": "بوابة الناشر",
    "greeting": {
      "morning": "صباح الخير، {{name}}.",
      "afternoon": "مساء الخير، {{name}}.",
      "evening": "مساء النور، {{name}}."
    },
    "submitTitle": "تقديم عنوان جديد",
    "viewAll": "عرض الكل {{n}}",
    "kpi": {
      "totalTitles": "إجمالي العناوين"
    },
    "breakdown": {
      "byStatus": "العناوين حسب الحالة"
    },
    "quota": {
      "title": "استخدام الخطة",
      "label": "العناوين المستخدمة",
      "remaining": "{{n}} من {{limit}} متبقٍ",
      "unlimited": "غير محدود"
    },
    "subscription": {
      "title": "الاشتراك",
      "expires": "يتجدد في {{date}}",
      "noExpiry": "لا يوجد تاريخ تجديد",
      "none": "لا توجد خطة نشطة",
      "subscribe": "اشترك",
      "status": {
        "active": "نشط",
        "trialing": "تجريبي",
        "past_due": "متأخر السداد",
        "canceled": "مُلغى",
        "incomplete": "غير مكتمل",
        "incomplete_expired": "منتهٍ",
        "unpaid": "غير مدفوع",
        "paused": "موقوف"
      }
    },
    "plan": {
      "none": "بدون خطة"
    },
    "activity": {
      "title": "النشاط الأخير",
      "kind": {
        "titleSubmitted": "تم تقديم عنوان",
        "titleApproved": "تمت الموافقة على عنوان",
        "titleSuspended": "تم تعليق عنوان",
        "revisionSubmitted": "تم تقديم مراجعة",
        "revisionApproved": "تمت الموافقة على مراجعة",
        "revisionRejected": "تم رفض مراجعة"
      },
      "relative": {
        "now": "الآن",
        "minutes": "قبل {{n}} د",
        "hours": "قبل {{n}} س",
        "days": "قبل {{n}} ي"
      }
    },
    "recentSubmissions": "آخر التقديمات",
    "fields": {
      "title": "العنوان",
      "status": "الحالة",
      "submitted": "تاريخ التقديم"
    }
  },
  "settings": {
    "sectionLabel": "الحساب والإعدادات",
    "pageTitle": "الإعدادات",
    "pageSubtitle": "إدارة الإشعارات واللغة والمظهر",
    "notifications": {
      "sectionTitle": "الإشعارات",
      "webPush": {
        "label": "إشعارات فورية",
        "description": "إشعارات في المتصفح"
      },
      "emailPush": {
        "label": "البريد الإلكتروني",
        "description": "إشعارات عبر البريد الإلكتروني"
      },
      "testPush": "اختبار Push",
      "testPushDone": "تم الإرسال!",
      "testEmail": "اختبار البريد",
      "testEmailDone": "تم الإرسال!",
      "statusDenied": "محظور — أعد التعيين عبر أيقونة 🔒 في شريط العنوان"
    },
    "language": {
      "sectionTitle": "اللغة",
      "rowLabel": "اللغة",
      "arAbbr": "عربي",
      "enAbbr": "الإنجليزية",
      "arCurrent": "العربية (الحالية)",
      "enCurrent": "الإنجليزية (الحالية)"
    },
    "appearance": {
      "sectionTitle": "المظهر",
      "rowLabel": "المظهر",
      "lightDescription": "وضع فاتح",
      "darkDescription": "وضع داكن",
      "systemDescription": "تبع النظام",
      "light": "فاتح",
      "dark": "داكن",
      "system": "النظام"
    }
  },
  "close": "إغلاق",
  "expand": "توسيع",
  "publisher": "الناشر",
  "title": "العنوان",
  "avatar": {
    "uploadPhoto": "رفع صورة",
    "changePhoto": "تغيير الصورة",
    "uploadError": "فشل رفع الصورة",
    "fileTooLarge": "حجم الملف يتجاوز الحد المسموح",
    "invalidType": "نوع الملف غير مدعوم",
    "photoAlt": "صورة الملف الشخصي لـ {{name}}"
  },
  "login": {
    "tagline": "بوابة النشر المتقدمة",
    "registeredSuccess": "تم إنشاء الحساب بنجاح. سجل دخولك الآن.",
    "verifiedSuccess": "تم التحقق من البريد الإلكتروني. سجل دخولك.",
    "showPassword": "إظهار كلمة المرور",
    "hidePassword": "إخفاء كلمة المرور",
    "errors": {
      "emailRequired": "البريد الإلكتروني مطلوب",
      "passwordRequired": "كلمة المرور مطلوبة",
      "invalidCredentials": "بيانات الدخول غير صحيحة"
    }
  },
  "errors": {
    "generic": "حدث خطأ. يرجى المحاولة مرة أخرى."
  },
  "revision": {
    "tags": {
      "added": "مُضاف",
      "changed": "مُعدَّل",
      "removed": "محذوف"
    },
    "needsAttention": "يحتاج انتباهاً",
    "validated": "تم التحقق",
    "invalid": "فشل التحقق",
    "was": "كان",
    "now": "أصبح",
    "current": "الحالي",
    "proposed": "المُقترَح",
    "fieldsChanged": "حقول مُعدَّلة",
    "filesReplaced": "ملفات مُستبدَلة",
    "changes": "تغييرات",
    "files": "ملفات"
  },
  "readOnly": {
    "banner": "انتهى اشتراكك — الوصول للقراءة فقط",
    "resubscribe": "إعادة الاشتراك",
    "disabledHint": "أعد الاشتراك لاستخدام هذا الإجراء"
  }
}